import styled from 'styled-components';
import FreeWifiSvg from '../../assets/amenities/free-wifi.svg';

const FreeWifiIcon = styled(FreeWifiSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
`;

export default FreeWifiIcon;
